var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4204 0L13.6931 8.12793L15.6879 3.33788L24.4204 0Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.604492 0.00952148L9.31357 3.33843L11.2077 8.1913L0.604492 0.00952148Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1035 17.2859L24.8447 17.3783L23.1878 23.1425L17.4023 21.5114L20.1035 17.2859Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89631 17.2859L7.58745 21.5114L1.81173 23.1426L0.164795 17.3783L4.89631 17.2859Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9503 6.95508L11.1441 13.3634L5.34619 13.0933L6.99537 10.5456L7.01625 10.521L10.9503 6.95508Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9898 6.88379L17.9839 10.5214L18.0046 10.5458L19.6538 13.0936L13.8572 13.3636L13.9898 6.88379Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75729 17.3044L10.9231 19.8303L7.24561 21.6485L7.75729 17.3044Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2433 17.304L17.7444 21.6484L14.0771 19.8301L17.2433 17.304Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.158 19.5923L17.8793 21.4375L14.4177 23.1222L14.4537 22.0087L14.158 19.5923Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8409 19.593L10.5568 21.9904L10.5801 23.1207L7.11035 21.4374L10.8409 19.593Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76641 14.2L10.7389 16.2927L7.42798 15.2996L9.76641 14.2Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2334 14.2002L17.5829 15.2996L14.2612 16.2925L15.2334 14.2002Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01033 17.283L7.47513 21.7869L4.60669 17.3814L8.01033 17.283Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9897 17.283L20.3935 17.3814L17.5142 21.7871L16.9897 17.283Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7374 12.8386L17.2603 15.4237L15.3505 14.53L14.4361 16.4984L13.8367 13.1135L19.7374 12.8386Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26123 12.8386L11.163 13.1136L10.5636 16.4985L9.649 14.5303L7.74923 15.4238L5.26123 12.8386Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09424 12.3083L7.89681 15.2204L7.99393 18.0953L5.09424 12.3083Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9085 12.303L17.0037 18.1003L17.113 15.2203L19.9085 12.303Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.026 12.4856L11.1388 13.2126L11.4175 15.0237L11.2383 20.5862L10.3911 16.1178L10.3909 16.0716L11.026 12.4856Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9724 12.4756L14.6092 16.0716L14.6089 16.1178L13.7596 20.5974L13.726 19.477L13.5935 14.9908L13.9724 12.4756Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3621 15.1045L17.2672 17.6023L14.3108 19.961L13.7131 19.5286L14.3831 15.9951L17.3621 15.1045Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64819 15.1047L10.6169 15.9953L11.2868 19.5288L10.6892 19.9612L7.73257 17.6023L7.64819 15.1047Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54468 20.8857L10.3271 22.7209L10.3111 21.9373L10.6276 21.6528H14.3711L14.699 21.9363L14.6749 22.7194L18.4333 20.8904L16.6045 22.4379L14.393 23.9933H10.5973L8.3872 22.4316L6.54468 20.8857Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.887 19.3479L14.4218 19.7347L14.7352 22.2952L14.2816 21.9031H10.7196L10.2747 22.3031L10.5778 19.7349L11.1127 19.3479H13.887Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7124 0.225098L25.0001 4.18085L24.1959 8.18049L24.7686 8.63286L23.9937 9.23824L24.576 9.69877L23.8049 10.4179L24.2783 10.769L23.0219 12.2716L17.8686 10.7352L17.8239 10.7106L14.1104 7.50279L23.7124 0.225098Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2877 0.225098L10.8898 7.50279L7.17621 10.7106L7.13155 10.7352L1.9782 12.2716L0.721798 10.769L1.19485 10.4182L0.424073 9.69878L1.00533 9.23874L0.218881 8.63163L0.813115 8.17898L0 4.18099L1.2877 0.225098Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6163 10.3989L23.0766 12.0268L24.8506 17.6254L20.1705 17.6254L16.9458 17.667L19.2909 12.9862L17.6163 10.3989Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38355 10.3989L5.70862 12.9862L8.05407 17.667L4.83094 17.6254H0.15918L1.92318 12.0268L7.38355 10.3989Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9555 3.31128L14.4282 7.53516L14.1041 13.2412L13.9801 15.0297L13.9702 19.5985H11.0297L11.0201 15.0383L10.8957 13.2397L10.5715 7.53516L9.04443 3.31128H15.9555Z",
    fill: "#F5841F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.6767e053c63fac390b6675d8361cd11f.svg";
export { ForwardRef as ReactComponent };